import React from 'react';
import { inject } from 'mobx-react';
import { MarketplaceOrderEditOrderLinesStepTemplate } from 'themes/modules/order/pages/wizard';

@inject(i => ({
	marketplaceOrderEditViewStore: i.rootStore.marketplaceOrderEditViewStore,
}))
class MarketplaceOrderEditOrderLinesStep extends React.Component {
	render() {
		return <MarketplaceOrderEditOrderLinesStepTemplate {...this.props} />;
	}
}

export default MarketplaceOrderEditOrderLinesStep;



// WEBPACK FOOTER //
// ./src/modules/order/pages/wizard/MarketplaceOrderEditOrderLinesStep.jsx